export const SEARCH_REQUEST = Symbol('SEARCH_REQUEST');
export const SEARCH_REQUEST_MOBILE = Symbol('SEARCH_REQUEST_MOBILE');
/**
 * @param {string} searchTerm
 * @param {number} pageNum
 * @param {string} sorting
 * @return {{type: symbol, payload: {searchTerm, pageNum}}}
 */
export const searchRequestAction = (searchTerm, perPage, pageNum = 1, sorting) => ({
  type: SEARCH_REQUEST,
  payload: { searchTerm, perPage, pageNum, sorting },
});

export const searchRequestOnMobileAction = (searchTerm, perPage, pageNum, prevVideos, sorting) => ({
  type: SEARCH_REQUEST_MOBILE,
  payload: { searchTerm, perPage, pageNum, prevVideos, sorting },
});
